import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  // NavbarBrand,
  Nav,
  // NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Button,
  Label
} from "reactstrap";

import { MasterSync } from "MasterSync";
import { api_link } from "siteConfig";

function AdminNavbar(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [color, setColor] = React.useState("transparent");
  const [syncDisabled, setSyncDisabled] = React.useState(false);
  const [syncCountdown, setSyncCountdown] = React.useState(0);
  const sidebarToggle = React.useRef();
  const toggle = () => {
    if (isOpen) {
      setColor("transparent");
    } else {
      setColor("white");
    }
    setIsOpen(!isOpen);
  };
  const dropdownToggle = (e) => {
    setDropdownOpen(!dropdownOpen);
  };
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("white");
    } else {
      setColor("transparent");
    }
  };
  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    // eslint-disable-next-line
  }, []);
  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);
  const unsetSession = () => {
    sessionStorage.clear()
    navigate('/auth/login-page')
  };

  const handleSync = () => {
    if (syncDisabled) return;
    
    setSyncDisabled(true);
    setSyncCountdown(5);
    
    // Start countdown
    const countdown = setInterval(() => {
      setSyncCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdown);
          setSyncDisabled(false);
          // Reload the page when timer finishes
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    // Execute the sync
    MasterSync(sessionStorage.getItem("subcon_id")).then(resp => { 
      // window.location.href='/admin/dashboard' 
    });
  };
  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
      color="white"
      expand="lg"
      className={ "navbar fixed-top " +
        (color === "transparent" ? " " : "") }
    >
      <Container fluid>
        <div className="navbar-wrapper">
          <div className="navbar-toggle">
            <button
              type="button"
              ref={sidebarToggle}
              className="navbar-toggler"
              onClick={() => openSidebar()}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          {/* <NavbarBrand href="/">{getBrand()}</NavbarBrand> */}
        </div>
        <NavbarToggler onClick={toggle}>
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar 
        // className="justify-content-start"
        style={{justifyContent: 'space-between'}}
        >
          {/* <form>
            <InputGroup className="no-border float-left">
              <Input placeholder="Search..." style={{width: '400px'}}/>
              <InputGroupAddon addonType="append">
                <InputGroupText>
                  <i className="now-ui-icons ui-1_zoom-bold" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </form> */}
          <Button 
            className="btn-round btn btn-success float-right" 
            onClick={handleSync}
            disabled={syncDisabled}
          >
            {syncDisabled ? `Sync (${syncCountdown}s)` : 'Sync'}
          </Button>
          <Label style={{color: 'red', fontStyle: 'bold', fontSize: '22pt'}}>
          {
            api_link === 'api.jcwes.com/v1.0/live/' ? '' : 'api.jcwes.com/v1.0/training/' ? '*** TRAINING SYSTEM ***' : '*** DEVELOPMENT SYSTEM ***'
          }
          </Label>
          <Nav navbar>
            <Dropdown
              nav
              isOpen={dropdownOpen}
              toggle={(e) => dropdownToggle(e)}
              className="float-right"
            >
              <DropdownToggle caret nav>
                <i className="now-ui-icons users_single-02" />
                {sessionStorage.getItem("fullname")} 
              </DropdownToggle>
              <DropdownMenu right>
                <Link to="/admin/change-password">
                  <DropdownItem>Change Password</DropdownItem>
                </Link>
                <Link to="/auth/login-page" onClick={unsetSession}>
                  <DropdownItem>Logout</DropdownItem>
                </Link>
              </DropdownMenu>
            </Dropdown>
            {/* <NavItem>
              <Link to="#pablo" className="nav-link">
                <i className="now-ui-icons users_single-02" />
                <p>
                  <span className="d-lg-none d-md-block">Account</span>
                </p>
              </Link>
            </NavItem> */}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default AdminNavbar;
